import React, { useEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {
  Grid, Typography, Divider, IconButton, FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Switch,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { GetApp } from '@material-ui/icons';
import serviciosSolicitudes from "utils/serviciosSolicitudes";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
      color: "red",
    },
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));
export default function FormularioSolicitud(props) {
  const { register, errors, setValue, watch, setCargando, defaultItem, getValues, isEdicion, ctlg, unregister, permisos } = props; //bucarEquipo
  const classes = useStyles();
  let arrNvlbono = [{ value: 1, label: 'SILVER' }, { value: 2, label: 'GOLD' }];
  // let arrNvlbono = [1,2,3];
  const cambioProyecto = (e, value) => {
    if (value.length > 0)
      setValue('proyecto', value);
    else
      setValue('proyecto', null);
  }

  const cambioCheck = (e, value) => {
    if (value)
      register('nvlbono', { required: { value: true, message: 'Campo requerido' } });
    else
      unregister('nvlbono')
    setValue('bono', value ? 1 : 0);

  }
  const [data, setData] = useState([]);
  // const [ctl, setCtl] = useState({ infoarchivos: [], infoarchivosReq: [] });

  // const servicios = {
  //   get: () => {
  //     serviciosSolicitudes.getDocumentos(
  //       (data) => {
  //         setCtl({
  //           ...ctl,
  //           infoarchivos: data.infoarchivos,
  //           infoarchivosReq: data.infoarchivosReq
  //           // indicadoresTareaP: data.indicadoresTareaP,
  //         });
  //       },
  //       setCargando,
  //       { idsolicitud: defaultItem.general.idsolicitud }
  //     );
  //   },
  // };

  // useEffect(() => {
  //   servicios.get(setData, setCargando);
  // }, []);

  const descargarDocs = () => {
    setCargando(true);
    ctlg.infoarchivos.forEach((element, i) => {
      //for (var i = 1; i <= ctl.infoarchivos.length; i++) {
      (function (index) {
        setTimeout(function () {

          const link = document.createElement("a");
          link.href = "https://dashboard.gphsis.com/back/Login/whatever/" + element.idarchivo;
          // link.href = "http://localhost/dashboardback/Login/whatever/"+element.idarchivo;
          link.download = 'filename';
          link.click();

          if ((ctlg.infoarchivos.length - 1) == i)
            setTimeout(function () {
              setCargando(false);
            }, 4000);
        }, (i + 1) * 3000);
      })(i);
    });
  };

  const descargarDocsReq = () => {
    setCargando(true);
    ctlg.infoarchivosReq.forEach((element, i) => {
      //for (var i = 1; i <= ctl.infoarchivos.length; i++) {
      (function (index) {
        setTimeout(function () {

          const link = document.createElement("a");
          link.href = "https://dashboard.gphsis.com/back/Login/obtenerArchivoReq/" + element.idarchivoreq + "/solicitud";
          // link.href = "http://localhost/dashboardback/Login/obtenerArchivoReq/" + element.idarchivoreq + "/solicitud";
          link.download = 'filename';
          link.click();

          if ((ctlg.infoarchivosReq.length - 1) == i)
            setTimeout(function () {
              setCargando(false);
            }, 4000);
        }, (i + 1) * 3000);
      })(i);
    });
  };
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item md={4} xs={6}>
        <Typography variant="body2">
          <b>TIPO DE SOLICITUD :</b>{" "}
          {defaultItem.general.ntipo_solicitud || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={3} xs={6}>
        <Typography variant="body2">
          <b>PRIORIDAD :</b> {defaultItem.general.nprioridad || "N/D"}
        </Typography>
      </Grid>

      {/* <a href={'http://localhost/dashboardback/Login/whatever/'+defaultItem.general.idsolicitud} download> clic me </a>  */}
      <Grid item md={4} xs={6}>
        <Typography variant="body2">
          <b>SISTEMA :</b> {defaultItem.general.sistema || "N/D"}
        </Typography>
      </Grid>
      {ctlg.infoarchivos.length > 0 && <Grid item md={1} xs={6}>
        <IconButton
          type="button"
          title="descargar archivos"
          size="small"
          onClick={descargarDocs}
          aria-label="descargar"
        >
          <GetApp />
        </IconButton>
      </Grid>
      }
      <Grid container item spacing={2}>
        <Grid item md={6} xs={12}>
          <Grid item md={12} xs={12}>
            <Typography variant="body2">
              <b>TÍTULO :</b> {defaultItem.general.titulo || "N/D"}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <Typography variant="body2">
              <b>SOLICITANTE :</b> {defaultItem.general.solicitante || "N/D"}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <Typography variant="body2">
              <b>SOLICITUD :</b> {defaultItem.general.problematica || "N/D"}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <Typography variant="body2">
              <b>CORREO DE CONTACTO :</b> {defaultItem.general.correo || "N/D"}
            </Typography>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12}>
          <Grid item md={12} xs={12}>
            <Typography variant="body2" >
              <b>DESCRIPCIÓN DE LA SOLICITUD :</b>{" "}
              {defaultItem.general.desc_solicitud || "N/D"}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}></Grid>
          {defaultItem?.propuesta && <Grid item md={12} xs={12}>
            <Typography variant="body2" align='center'>
              <b>FECHA PROPUESTA</b>{" "}
              <Grid container item spacing={2}>
                <Grid item md={4} xs={4}>
                  <Typography variant="body2">
                    <b>HORA(S):</b>{" "}
                    {defaultItem.propuesta.nhoras || "N/D"}
                  </Typography>
                </Grid>
                <Grid item md={4} xs={4}>
                  <Typography variant="body2">
                    <b>FECHA INICIO:</b>{" "}
                    {defaultItem.propuesta.finicio || "N/D"}
                  </Typography>
                </Grid>
                <Grid item md={4} xs={4}>
                  <Typography variant="body2">
                    <b>FECHA FIN:</b>{" "}
                    {defaultItem.propuesta.ffin || "N/D"}
                  </Typography>
                </Grid>
              </Grid>
            </Typography>
          </Grid>}
        </Grid>
      </Grid>
      <Grid container item spacing={2}>
        {(defaultItem.general?.aplicarReq || '') &&
          <Grid item md={6} xs={12}>
            {(ctlg.infoarchivosReq.length > 0) && <React.Fragment>
              <Grid container item spacing={2}>
                <Grid item md={6} xs={6}>
                  <Typography variant="body2">
                    <b>REQUERIMIENTOS :</b>{" "}
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6}>
                  <IconButton
                    type="button"
                    title="descargar archivos requerimientos"
                    size="small"
                    onClick={descargarDocsReq}
                    aria-label="descargar"
                  >
                    <GetApp />
                  </IconButton>
                </Grid>
              </Grid></React.Fragment>}
          </Grid>
        }
        <Grid item md={6} xs={12}>
          <Grid item md={12} xs={12}>
            <Typography variant="body2">
              <b># HORAS TESTEO :</b>{" "}
              {defaultItem.general.hrs_testeo || "N/D"}
            </Typography>
          </Grid>
        </Grid>
        {defaultItem.general?.requerimiento &&
          <Grid item md={12} xs={12}>
            <Grid item md={12} xs={12}>
              <Typography variant="body2">
                <b>REQUERIMIENTOS :</b>{" "}
                {defaultItem.general.requerimiento || "N/D"}
              </Typography>
            </Grid>
          </Grid>
        }
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      {permisos && !permisos['requerimientos'] && <Grid item md={4} xs={12}>
        <Autocomplete
          multiple
          options={ctlg.proyectos}
          getOptionLabel={(option) => option.nproyecto}
          getOptionSelected={(option, value) =>
            option.idproyecto == value.idproyecto
          }
          value={watch("proyecto") || []}
          onChange={cambioProyecto}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField
              label="PROYECTOS"
              variant="outlined"
              {...params}
              error={errors.proyecto != undefined}
              helperText={errors.proyecto}
            />
          )}
          disabled={isEdicion}
        />
      </Grid>
      }
      {permisos && permisos['bono'] && <Grid item md={2} xs={6}>
        <FormControl component="fieldset">
          <FormGroup>
            <FormControlLabel
              control={<Checkbox name="replicar" checked={watch('bono') == 1 ? true : false} onChange={cambioCheck} />}
              label="SUSCEPTIBLE DE BONO" />
          </FormGroup>
        </FormControl>
      </Grid>
      }
      {getValues('bono') == 1 && <Grid item md={3} xs={6}>
        <Autocomplete
          options={arrNvlbono}
          getOptionLabel={(option) => option.label}
          getOptionSelected={(option, value) => option.value == value.value}
          value={watch('nvlbono') || []}
          onChange={(e, value) => { setValue('nvlbono', value) }}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField label="NIVEL DE BONO" variant="outlined" {...params}
              error={errors.nvlbono != undefined} helperText={errors.nvlbono}
            />
          )}
        // disabled={isEdicion}
        />
      </Grid>
      }
      <Grid item md={3} xs={6}>
        <FormControl component="fieldset">
          <FormGroup>
            <FormControlLabel
              control={<Checkbox name="replicar" checked={watch('presentacion') == 1 ? true : false} onChange={(e, value) => { setValue('presentacion', value) }} disabled={isEdicion} />}
              label="APLICAR PRESENTACIÓN DE ENTREGA" />
          </FormGroup>
        </FormControl>
      </Grid>
      {/* {permisos && permisos['requerimientos'] && <Grid item md={3} xs={6}>
        <Autocomplete
          options={ctlg.responsables}
          getOptionLabel={(option) => option.npersona}
          getOptionSelected={(option, value) => option.value == value.value}
          value={watch('responsable') || []}
          onChange={(e, value) => { setValue('responsable',value )} }
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField label="RESPONSABLE" variant="outlined" {...params}
              error={errors.responsable != undefined} helperText={errors.responsable}
            />
          )}
          // disabled={isEdicion}
        />
        </Grid>
      } */}
    </Grid>
  );
}
